window.VersionManagerAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("VersionManagerServer"));


    self.loadWebVersion = function (currentVersion, brandId) {

        var defer = $q.defer();

        _protected.request('web_versions', 'GET', {version: currentVersion, brand_id: brandId})
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

};